import {
  CircleAlert,
  LoaderCircle,
  X,
} from 'lucide-react'
import { useEffect } from 'react'

function Fila({
  etiqueta,
  valor,
  destacado = false,
}) {
  return (
    <div className="flex items-start justify-between gap-4 py-2">
      <dt className="text-sm text-slate-500">
        {etiqueta}
      </dt>

      <dd
        className={`min-w-0 break-words text-right ${
          destacado
            ? 'text-lg font-bold text-emerald-700'
            : 'text-sm font-semibold text-slate-900'
        }`}
      >
        {valor}
      </dd>
    </div>
  )
}

// Resumen previo a registrar la compra. No usa window.confirm: mismo
// lenguaje visual que ModalMensaje, pero con el detalle de la compra.
function ConfirmarCompraModal({
  abierto,
  resumen,
  procesando = false,
  onCancelar,
  onConfirmar,
}) {
  useEffect(() => {
    if (!abierto) return

    const alPresionarTecla = (event) => {
      if (event.key === 'Escape' && !procesando) {
        onCancelar?.()
      }
    }

    document.addEventListener('keydown', alPresionarTecla)

    return () => {
      document.removeEventListener('keydown', alPresionarTecla)
    }
  }, [abierto, procesando, onCancelar])

  if (!abierto || !resumen) return null

  const alHacerClicFuera = (event) => {
    if (procesando) return

    if (event.target === event.currentTarget) {
      onCancelar?.()
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onMouseDown={alHacerClicFuera}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmar-compra-titulo"
        className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-6 shadow-xl sm:p-8"
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <CircleAlert size={22} />
            </div>

            <h2
              id="confirmar-compra-titulo"
              className="text-lg font-bold text-slate-900"
            >
              Confirmar compra
            </h2>
          </div>

          <button
            type="button"
            onClick={onCancelar}
            disabled={procesando}
            aria-label="Cerrar"
            className="shrink-0 text-slate-400 transition hover:text-slate-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <X size={22} />
          </button>
        </div>

        <p className="mt-4 text-sm text-slate-600">
          Revisa el resumen antes de registrar la compra.
        </p>

        <dl className="mt-4 divide-y divide-slate-100 rounded-xl border border-slate-200 bg-slate-50 px-4">
          <Fila
            etiqueta="Proveedor"
            valor={resumen.proveedor}
          />

          <Fila
            etiqueta="Producto"
            valor={resumen.producto}
          />

          <Fila
            etiqueta="Cantidad cajas"
            valor={resumen.cantidadCajas}
          />

          <Fila
            etiqueta="Kg netos"
            valor={resumen.kilosNetos}
          />

          <Fila
            etiqueta="Precio/kg"
            valor={resumen.precioKilo}
          />

          <Fila
            etiqueta="Total compra"
            valor={resumen.totalCompra}
            destacado
          />
        </dl>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancelar}
            disabled={procesando}
            className="min-h-12 w-full rounded-lg border border-slate-300 px-5 py-3 font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={onConfirmar}
            disabled={procesando}
            className="flex min-h-12 w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-3 font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-emerald-400 sm:w-auto"
          >
            {procesando && (
              <LoaderCircle
                size={18}
                className="animate-spin"
              />
            )}
            {procesando ? 'Registrando...' : 'Confirmar compra'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmarCompraModal
